import 'core-js/stable'
import 'regenerator-runtime/runtime'

import initGlobal, { initPageFooter, initPageHeader } from '@bikemap/js/integrations/global'
import { getInviteWidgetOptions, initInviteWidget } from '@bikemap/js/integrations/premium'

initGlobal()
initPageHeader()
initPageFooter()

getInviteWidgetOptions().then(options => {
    initInviteWidget('js-load-invite-widget-invite-friends', options)
})
